<template>
  <v-container>
    <carregando
      v-if="loading"
    />
    <v-card v-else>
      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>Recurso da Habilitação</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form
          ref="form_recurso_habilitacao"
          v-model="valid"
          lazy-validation
        >
          <v-layout class="mt-1">
            <v-flex
              xs12
              sm6
            >
              <div class="ma-12 text-justify subheading grey--text">
                <span class="font-weight-bold">Nome do organizacao:</span> {{ habilitacaoOrganizacao.organizacao.no_organizacao }}
              </div>
            </v-flex>
          </v-layout>


          <v-layout class="mt-1">
            <v-flex
              md12
              subheading
              grey--text
              mt-2
              d-inline-flex
            >
              <div class="md6">
                <span class="font-weight-bold">CNPJ da Organização ou Entidade Cultural:</span> {{ habilitacaoOrganizacao.organizacao.cnpj_formatado }}
              </div>

              <div class="md6">
                <span class="font-weight-bold">Nome da Organização ou Entidade Cultural:</span> {{ habilitacaoOrganizacao.organizacao.no_organizacao }}
              </div>
            </v-flex>
          </v-layout>

          <habilitacao-organizacao-detalhes-visualizacao
            mostrar-indeferidos-apenas
          />
          <v-layout
            row
            wrap
          >
            <v-flex
              sm12
            >
              <v-flex
                title
                text--secondary
                my-3
              >
                Recurso
              </v-flex>
            </v-flex>
            <v-flex
              sm12
            >
              <v-card class="mt-2 ml-3">
                <v-card-title
                  primary-title
                >
                  <h4>
                    <b>
                      Em atenção ao resultado parcial da habilitação, referente à análise dos critérios e da documentação informados no momento da inscrição, informamos que o participante terá o prazo de 3 a 7 de outubro de 2022 para interpor recurso, com a possibilidade de correção de eventual documentação avaliada como "irregular", cujos arquivos corrigidos deverão ser encaminhados para o endereço eletrônico <span class="indigo--text font-weight-bold">votacultura@turismo.gov.br</span>, com a respectiva justificativa de cada item recorrido.
                    </b>
                  </h4>
                  <br/>
                  <h4>
                  <b>
                    Em decorrência de imprevisto de ordem técnica, o recurso será encaminhado por e-mail, conforme informado acima, em substituição ao previsto no item 6.6 do edital.
                  </b>
                </h4>
                </v-card-title>
                <v-checkbox
                v-model="confirmacaoDadosRecurso"
                :rules="[rules.required]"
                :disabled="Object.keys(recursoHabilitacao).length > 0"
                label="Declaro ser representante da organização ou entidade cultural inscrita neste edital, que li e estou de acordo com procedimento de encaminhar as informações do recurso."
              />
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-layout
        wrap
        align-center
      >
        <v-flex 
        v-if="!Object.keys(recursoHabilitacao).length > 0"
        offset-xs5>
          <v-btn to="/">
            Cancelar
          </v-btn>
          <v-btn
            :readonly="isLocked"
            :disabled="isLocked || !valid || !confirmacaoDadosRecurso"
            color="primary"
            @click="abrirDialogo"
          >
            Enviar
          </v-btn>
        </v-flex>
        <v-flex 
        v-else
        offset-xs5>
        <v-flex
                title
                indigo--text
                my-3
              >
                Recurso Solicitado
              </v-flex>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout justify-center>
      <dialog-confirmacao
        v-model="dialog"
        title="Deseja realmente enviar?"
        text="Os dados enviados não poderão ser alterados posteriormente."
        cancel-text="Não"
        confirm-text="Sim"
        :is-loading="loading"
        @dialog-response="respostaDialog"
      />
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import Carregando from '../../shared/components/CardCarregando';
import codigosFase from '../../fase/utils/codigosFase';
import DialogConfirmacao from '../../shared/components/DialogConfirmacao';
import HabilitacaoOrganizacaoDetalhesVisualizacao from '../../organizacao/views/HabilitacaoOrganizacaoDetalhesVisualizacao';

export default {
  components: {
    Carregando,
    DialogConfirmacao,
    HabilitacaoOrganizacaoDetalhesVisualizacao,
  },
  data: () => ({
    codigosFase,
    dialog: false,
    valid: false,
    isUsuarioPermitido: false,
    usuarioLogado: {},
    perfilUsuario: {},
    loading: true,
    confirmacaoDadosRecurso: false,
    recurso_habilitacao_organizacao: {
      arquivos: [],
    },
    isLocked: false,
    rules: {
      required: value => !!value || 'Campo não preenchido',
      tamanhoMaximoCaracteres: value => (!!value && value.length <= 3000) || 'Máximo 3000 caracteres',
    },
  }),
  watch: {
    habilitacaoOrganizacao(habilitacao) {
      this.obterPorHabilitacaoOrganizacao(habilitacao.co_habilitacao_organizacao);
      this.recurso_habilitacao_organizacao.arquivos = [];
      this.loading = false;
    },
    recursoHabilitacao(recurso) {
      if(recurso){
        this.recurso_habilitacao_organizacao = {};
        this.recurso_habilitacao_organizacao.arquivos = [];
        this.recurso_habilitacao_organizacao = Object.assign({}, recurso);
        this.confirmacaoDadosRecurso = true;
      }
    },
    fases() {
      this.checkRecursoHabilitacao();
    },
    usuarioLogado(user) {
      this.obterDadosHabilitacaoOrganizacao(user.co_organizacao);
    },
  },
  computed: {
    ...mapGetters({
      fases: 'fase/fases',
      usuario: 'conta/usuario',
      perfil: 'conta/perfil',
      organizacao: 'organizacao/organizacaoUsuarioLogado',
      habilitacaoOrganizacao: 'organizacao/habilitacaoOrganizacao',
      ativarRecursoHabilitacaoOrganizacao: 'fase/ativarRecursoHabilitacaoOrganizacao',
      recursoHabilitacao: 'recurso/recurso',
    }),
  },
  methods: {
    ...mapActions({
      definirMensagemSucesso: 'app/setMensagemSucesso',
      definirMensagemErro: 'app/setMensagemErro',
      obterDadosHabilitacaoOrganizacao: 'organizacao/obterDadosHabilitacaoOrganizacao',
      enviarDadosRecursoHabilitacaoOrganizacao: 'recurso/enviarDadosRecursoHabilitacaoOrganizacao',
      obterPorHabilitacaoOrganizacao: 'recurso/obterPorHabilitacaoOrganizacao',
      downloadArquivo: 'shared/downloadArquivo',
    }),
    respostaDialog(tipoResposta) {
      if (tipoResposta) {
        this.salvar();
      } else {
        this.fecharDialogo();
      }
    },
    salvar() {
      this.recurso_habilitacao_organizacao.co_habilitacao_organizacao = this.habilitacaoOrganizacao.co_habilitacao_organizacao;
      this.recurso_habilitacao_organizacao.ds_recurso = 'Dados do recurso enviados através de email para o endereço: votacultura@turismo.gov.br'
      this.validarAnexos();
      this.loading = true;

      this.enviarDadosRecursoHabilitacaoOrganizacao(this.recurso_habilitacao_organizacao)
        .then((response) => {
          this.definirMensagemSucesso(response.data.message);
          this.$router.push('/');
        }).finally(() => {
          this.loading = false;
          this.fecharDialogo();
        });
    },
    validarAnexos() {
      this.recurso_habilitacao_organizacao.arquivos.forEach((item) => {
        if (Object.values(item).length === 0) {
          return;
        }

        this.anexos.push({
          tp_arquivo: item.tp_arquivo,
          no_extensao: item.arquivo.fileExtension,
          no_mime_type: item.arquivo.fileType,
          no_arquivo: item.arquivo.filename,
          arquivoCodificado: item.arquivo.getFileEncodeBase64String(),
        });
      });
      this.recurso_habilitacao_organizacao.arquivos = [];
      this.recurso_habilitacao_organizacao.anexos = this.anexos;
    },
    abrirDialogo() {
      if (!this.$refs.form_recurso_habilitacao.validate()) {
        return false;
      }
      this.dialog = true;
      return true;
    },
    fecharDialogo() {
      this.dialog = false;
    },
    checkRecursoHabilitacao() {
      if (!this.isActiveRecursoHabilitacao()) {
        this.definirMensagemErro('Recurso da Habilitação indisponível!');
        this.$router.push('/').catch(() => {});
      }
    },
    checkUsuario() {
      if (!this.isUsuarioPermitido) {
        this.definirMensagemErro('Organizacao de Cultura ou Organizações e Entidades Cultural não associada ao perfil');
        this.$router.push('/').catch(() => {});
      }
      return true;
    },
    isActiveRecursoHabilitacao() {
      let faseRecursoHabilitacao = this.fases.find(f => f.tp_fase == codigosFase.TP_RECURSO_HABILITACAO_ORGANIZACAO);
      const dataInicio = moment(faseRecursoHabilitacao.dh_inicio).toDate().getTime();
      const dataAtual = moment().toDate().getTime();

      return dataAtual >= dataInicio;
    },
    fileAdded() {
      this.fileLoaded = !this.fileLoaded;
    },
  },
  mounted() {
    this.isUsuarioPermitido = (this.perfil.no_perfil == 'organizacao');
    
    if (this.fases && this.fases.length > 0) {
      this.checkRecursoHabilitacao();
    }

    this.checkUsuario();

    this.usuarioLogado = this.usuario;
    this.perfilUsuario = this.perfil;
  },
};
</script>
